var ApplicantAPI = require("../../common/api/applicant");
var AuthStore = require("../../common/auth")
var AuthAPI = require('../../common/api/auth');

module.exports = function ApplicantRegistrationController($scope, $state, $window, ngDialog) {
  var vm = this;
  vm.showQuestions = true;
  vm.loading = false;
  vm.funderSearchUrl = '/search?text=&sort=Relevance&simple&type=Funder&pageNumber=1&pageSize=6&searchOnLoad=true';

  vm.submitQuetstions = function(){
    $state.go('public.applicantRegistrationConfirmed');
  }
  vm.displayNotification = function() {
    vm.loading = false;
    var dialog = ngDialog.open({
      template: require("./dialogs/notify.pug")(),
      controller: require("./dialogs/notify.js"),
      controllerAs: 'vm',
      plain: true,
      disableAnimation: false,
      className: "ge-dialog-medium ngdialog-theme-default"
    });

    dialog.closePromise.then(function(obj) {
      if (obj.value.action == "close") return;
      if (obj.value.action == "cancel" ){
        window.location = "/";
        return;
      }
      if (obj.value.action == "confirm") {
        //send email
        var a = obj.value.applicant;
        ApplicantAPI.RequestApplicantInvitation(a.applicantId, a.contactName,
        a.contactNumber, a.email, a.position);
        vm.displayClosingNotification();
      }
    })
  }
  vm.displayNotification();

  vm.displayClosingNotification = function() {
    vm.loading = false;
    var dialog = ngDialog.open({
      template: require("./dialogs/requestEmail.pug")(),
      controller: require("./dialogs/requestEmail.js"),
      plain: true,
      disableAnimation: false,
      className: "ge-dialog-medium ngdialog-theme-default",
      closeByDocument: false
    });

    dialog.closePromise.then(function(obj) {
      window.location = "/login";
    })
  }
};
